/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { LoggingHelper as logging } from 'sarsaparilla';
import {
    GET_SEARCH_RECAREA,
    GET_SEARCH_RECAREA_ERROR,
    GET_SEARCH_RECAREA_NAME,
    GET_SEARCH_RECAREA_NAME_ERROR,
} from '../constants';
import { campingSearchAxios } from '../utils/externalAxios';
import { urlWithParams } from '../utils/utils';

// fetch doesn't handle errors well
const status = (response) => {
    if (response.status >= 200 && response.status < 300) {
        return Promise.resolve(response);
    }
    logging.logError(response.statusText);
    return Promise.reject(new Error(response.statusText));
};

export const recareaNameFailed = (message) => ({
    type: GET_SEARCH_RECAREA_NAME_ERROR,
    payload: message,
    error: true,
});

export const recareaFailed = (message) => ({
    type: GET_SEARCH_RECAREA_ERROR,
    payload: message,
    error: true,
});

export const fetchRecareaName = (recareaID) => (dispatch) => {
    if (!recareaID) {
        dispatch({ type: GET_SEARCH_RECAREA_NAME, payload: {} });
        return new Promise((resolve) => {
            resolve();
        });
    }
    const args = {
        fq: ['entity_type:recarea', `entity_id:${recareaID}`],
    };
    const url = urlWithParams(`${process.env.API}/search`, args);
    return campingSearchAxios
        .get(url)
        .then(status)
        .then((json) => json.data)
        .then((json) => {
            if (json.size < 1) {
                dispatch(recareaNameFailed('Error recarea not found'));
            } else {
                const pl = json.results[0];
                pl.id = recareaID;
                dispatch({ type: GET_SEARCH_RECAREA_NAME, payload: pl });
            }
        })
        .catch((error) => {
            if (error.response && error.response.data) {
                dispatch(recareaNameFailed('Error recarea name results.'));
            }
        });
};

export const fetchRecarea = (recareaID) => (dispatch) => {
    const args = {
        fq: ['entity_type:recarea', `entity_id:${recareaID}`],
    };
    const url = urlWithParams(`${process.env.API}/search`, args);
    return campingSearchAxios
        .get(url)
        .then(status)
        .then((json) => json.data)
        .then((json) => {
            if (json.size < 1) {
                dispatch(recareaFailed('Error recarea not found'));
            } else {
                const pl = json.results[0];
                pl.id = recareaID;
                dispatch({ type: GET_SEARCH_RECAREA, payload: pl });
            }
        })
        .catch((error) => {
            if (error.response && error.response.data) {
                dispatch(recareaFailed('Error recarea results.'));
            }
        });
};
